var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "descriptionContent row" }, [
    _c("div", { staticClass: "col-5 col-md-4 mb-md-0 mb-2" }, [
      _c("img", {
        staticClass: "openPorto",
        attrs: { src: _vm.shippingIconUrl, alt: _vm.shippingName },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "detail col-md-8 col-12" }, [
      _c("span", {
        staticClass: "name mb-2",
        domProps: { innerHTML: _vm._s(_vm.shippingName) },
      }),
      _vm._v(" "),
      _c("ul", { staticClass: "ship" }, [
        _c("li", {
          domProps: {
            innerHTML: _vm._s(
              _vm.shippingCosts + " innerhalb " + _vm.countryName
            ),
          },
        }),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("biokinder-availability", {
              attrs: { short: true, avd: _vm.avd, variation: _vm.variation },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("li", { domProps: { innerHTML: _vm._s(_vm.middleLlistElement) } }),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "openPorto",
              attrs: {
                "data-toggle": "modal",
                href: "#shippingscosts",
                title: _vm.$translate(
                  "Ceres::Template.singleItemShippingCosts"
                ),
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$translate(
                    "biokinderDesign::Template.itemMoreInformation"
                  )
                )
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }